// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textField {
  background-color: transparent;
  border-radius: 4px;
  color: #b3b0c1;
}

.textField .MuiOutlinedInput-notchedOutline,
.textField:hover .MuiOutlinedInput-notchedOutline,
.textField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}
.css-bgr7de-MuiPaper-root-MuiAccordion-root {
  gap: 0px !important;
}
.css-yfrx4k-MuiAccordionSummary-content.Mui-expanded {
  margin: 0px !important;
}
.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {
  height: 22px !important;
}
.textField .MuiInputBase-input {
  color: #ffffff;
}

.textField .MuiInputLabel-root,
.textField .MuiInputLabel-root.Mui-focused,
.textField .MuiInputLabel-root.Mui-disabled {
  color: #b3b0c1;
}x
.selectField {
  background-color: #2b2a3c; /* Dark gray background */
  border-radius: 4px;
  color: #b3b0c1;
}

.selectField .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField:hover .MuiOutlinedInput-notchedOutline,
.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #ffffff; 
}

.selectField .MuiInputBase-input {
  color: #ffffff;
}

.selectField .MuiInputLabel-root {
  color: #b3b0c1;
}

.selectField .MuiInputLabel-root.Mui-focused {
  color: #ffffff;
}

.selectField .MuiSelect-icon {
  color: #b3b0c1; 
}

.selectField .MuiMenuItem-root {
  color: #ffffff; 
  background-color: #2b2a3c;
}

.selectField .MuiMenuItem-root:hover {
  background-color: #383750; 
}
/*select  */
.selectField {
  color: #b3b0c1;
}

.selectField .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField:hover .MuiOutlinedInput-notchedOutline,
.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #b3b0c1;
}

.selectField .MuiSelect-icon {
  color: #b3b0c1;
}
/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper.css-6odml8-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{
  background-color: #2b2a3c;
} */
.countContainer{
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  justify-content: space-between;
}
.buttonContainer{
  display: flex;
  justify-content: space-between;
  gap: 5px;
  margin: 5px 5px;
}
.MuiTypography-root.countText{
  color: #b3b0c1;
  margin-left: 20px;
}
/* prompt */
.promptContainer{
  display: flex;
  gap: 5px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModelForm/ModalForm.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB,CAAC;;EAEC,yBAAyB,EAAE,yBAAyB;EACpD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA,WAAW;AACX;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;AACA;;GAEG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB","sourcesContent":[".textField {\n  background-color: transparent;\n  border-radius: 4px;\n  color: #b3b0c1;\n}\n\n.textField .MuiOutlinedInput-notchedOutline,\n.textField:hover .MuiOutlinedInput-notchedOutline,\n.textField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n.css-bgr7de-MuiPaper-root-MuiAccordion-root {\n  gap: 0px !important;\n}\n.css-yfrx4k-MuiAccordionSummary-content.Mui-expanded {\n  margin: 0px !important;\n}\n.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded {\n  height: 22px !important;\n}\n.textField .MuiInputBase-input {\n  color: #ffffff;\n}\n\n.textField .MuiInputLabel-root,\n.textField .MuiInputLabel-root.Mui-focused,\n.textField .MuiInputLabel-root.Mui-disabled {\n  color: #b3b0c1;\n}x\n.selectField {\n  background-color: #2b2a3c; /* Dark gray background */\n  border-radius: 4px;\n  color: #b3b0c1;\n}\n\n.selectField .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField:hover .MuiOutlinedInput-notchedOutline,\n.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #ffffff; \n}\n\n.selectField .MuiInputBase-input {\n  color: #ffffff;\n}\n\n.selectField .MuiInputLabel-root {\n  color: #b3b0c1;\n}\n\n.selectField .MuiInputLabel-root.Mui-focused {\n  color: #ffffff;\n}\n\n.selectField .MuiSelect-icon {\n  color: #b3b0c1; \n}\n\n.selectField .MuiMenuItem-root {\n  color: #ffffff; \n  background-color: #2b2a3c;\n}\n\n.selectField .MuiMenuItem-root:hover {\n  background-color: #383750; \n}\n/*select  */\n.selectField {\n  color: #b3b0c1;\n}\n\n.selectField .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField:hover .MuiOutlinedInput-notchedOutline,\n.selectField.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #b3b0c1;\n}\n\n.selectField .MuiSelect-icon {\n  color: #b3b0c1;\n}\n/* .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8.MuiPopover-paper.MuiMenu-paper.MuiMenu-paper.css-6odml8-MuiPaper-root-MuiPopover-paper-MuiMenu-paper{\n  background-color: #2b2a3c;\n} */\n.countContainer{\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 10px;\n  justify-content: space-between;\n}\n.buttonContainer{\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n  margin: 5px 5px;\n}\n.MuiTypography-root.countText{\n  color: #b3b0c1;\n  margin-left: 20px;\n}\n/* prompt */\n.promptContainer{\n  display: flex;\n  gap: 5px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
